// Validation Rules

// Validate Credit Card Number
const validateCardNumber = (number) => {
  var regex = new RegExp("^[0-9]{16}$");
  if (!regex.test(number))
      return false;

  return luhnCheck(number);
}

const luhnCheck = (val) => {
  var sum = 0;
  for (var i = 0; i < val.length; i++) {
      var intVal = parseInt(val.substr(i, 1));
      if (i % 2 == 0) {
          intVal *= 2;
          if (intVal > 9) {
              intVal = 1 + (intVal % 10);
          }
      }
      sum += intVal;
  }
  return (sum % 10) == 0;
}


export const required = value => value ? undefined : 'Required';

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
    'Please enter a valid email address' : undefined;

export const passwordsMatch = (value, allValues) =>
  value !== allValues.password ? 'Passwords don\'t match' : undefined;

export const number = value => value && !/^(?=.*[0-9])[- +()0-9]+$/.test(value) ? 'Must be a number' : undefined;

export const minLength = min => value => value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const bsbMinLength = value => value && value.length < 6 ? `BSB must be 6 digits` : undefined;

export const maxLength = max => value => value && value.length > max ? `Max ${max} characters` : undefined;

export const fixedLength = length => value => value && value.length !== length ? `Must be ${length} characters` : undefined;

export const noTransfer = (value, allValues, props) => allValues.Coding.length > 1 && allValues.Coding.find(item => item.AccountCode && item.AccountCode.accountType === 9) ? 'Cannot split a transfer' : undefined;

export const creditCard = value => value && validateCardNumber(value) ? undefined : 'Not a valid card number';

export const maxLength3 = maxLength(3);

export const maxLength30 = maxLength(30);

export const maxLength50 = maxLength(50);

export const none = () => undefined;

export const normalizeNumber = (value, previousValue) => {
  if (!value) {
    return value
  }
  return value.replace(/[^0-9\.\-]+/g, '');
}

export const normalizeAccNumber = (value, previousValue) => {
  if (!value) {
    return value
  }

  if (previousValue && value.length >= previousValue.length && previousValue.length === 20) {
    return
  }
  return value.replace(/[^0-9]+/g, '');
}

export const normalizeAccName = (value, previousValue) => {
  if (!value) {
    return value
  }
  if (previousValue && value.length >= previousValue.length && previousValue.length === 30) {
    return
  }
  return value;
}

export const normalizeAmount = (value, previousValue) => {
  if (!value) {
    return value
  }
  if (value.match(/^([1-9][0-9]*(\.[0-9]{0,2})?|[0]\.[0-9]{0,2})$/g)) {
    return value
  } else return previousValue
}

export const normalizePercent = (value, previousValue) => {
  if (!value) {
    return value
  }
  if (value.match(/^([1-9][0-9]*(\.[0-9]{0,2})?|[0]\.[0-9]{0,2})$/g) && value <= 100) {
    return value
  } else return previousValue
}

export const normalizeNumberMax = max => (value, previousValue) => {
  if (!value) {
    return value
  }

  if (previousValue && value.length >= previousValue.length && previousValue.length === max) {
    return
  }

  return value.replace(/[^0-9]+/g, '');
}

export const normalizeMax = max => (value, previousValue) => {
  if (previousValue && value.length >= previousValue.length && previousValue.length === max) {
    return
  }
  return value
}

export const normalizeASB = (value, previousValue) => {
  if (!value) {
    return value
  }
  const newValue = value.replace(/[\s\-]+/g, '');
  return (newValue.length > 6 && newValue.length < 13) ? newValue.slice(0, -1) + 'X' : newValue;
}

export const normalizeMax8 = normalizeMax(8);

export const normalizeMaxNumber = {};

export const minLengthVal = {};
export const maxLengthVal = {};

export const fixedLengthVal = {};

for (let i = 0; i < 11; i++) {
  normalizeMaxNumber[i] = normalizeNumberMax(i);

  minLengthVal[i] = minLength(i);
  maxLengthVal[i] = maxLength(i);
  fixedLengthVal[i] = fixedLength(i);
}


// WEBPACK FOOTER //
// ./src/components/Common/Validation.js